import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';

const useStyles = makeStyles((theme) =>
  createStyles({
    label: {
      fontSize: 18,
      transform: 'translate(12px, 15px) scale(1)',
      '&.Mui-focused': {
        color: theme.palette.secondary.main,
      },
      '&.MuiInputLabel-shrink': {
        transform: 'translate(12px, -6px) scale(0.6)',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
        transform: 'translate(12px, 14px) scale(1)',
        '&.MuiInputLabel-shrink': {
          transform: 'translate(12px, -4px) scale(0.7)',
        },
      },
    },
    wrapper: {
      height: 48,
      color: theme.palette.grey['700'],
      fontSize: 18,
      background: theme.palette.common.white,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.grey.A200}`,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.secondary.main}`,
      },
      [theme.breakpoints.down('xs')]: {
        height: 42,
        fontSize: 16,
      },
      '& input': {
        padding: '0 12px',
        fontSize: 18,
        height: 'unset',
        [theme.breakpoints.down('xs')]: {
          padding: '0 10px',
          fontSize: 16,
        },
      },
      '& fieldset': {
        border: `1px solid ${theme.palette.grey.A200}`,
        borderRadius: 3,
      },
    },
  }),
);

interface Props {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: () => void;
  value?: number | string;
  name?: string;
  type?: string;
  disabled?: boolean;
  label?: string;
  labelWidth?: number;
  placeholder?: string;
  adornment?: string;
  error?: boolean;
  errorText?: string;
  inputRef?: React.Ref<any>;
}

const AdornmentInput: React.FC<Props> = ({
  onChange,
  onBlur,
  value = '',
  name = '',
  type = 'text',
  disabled = false,
  label = '',
  labelWidth = 0,
  placeholder = '',
  adornment = '',
  error = false,
  errorText = '',
  inputRef,
}) => {
  const classes = useStyles();

  return (
    <div>
      <FormControl variant="outlined" fullWidth error={error}>
        {label && (
          <InputLabel className={classes.label} error={error}>
            {label}
          </InputLabel>
        )}
        <OutlinedInput
          onChange={onChange}
          onBlur={() => onBlur && onBlur!()}
          value={value}
          name={name}
          type={type}
          disabled={disabled}
          className={classes.wrapper}
          labelWidth={labelWidth}
          placeholder={placeholder}
          error={error}
          endAdornment={
            <InputAdornment disableTypography position="end">
              {adornment}
            </InputAdornment>
          }
          inputRef={inputRef}
        />
        {errorText && <FormHelperText error>{errorText}</FormHelperText>}
      </FormControl>
    </div>
  );
};

export default AdornmentInput;
